import { CommonModule, DecimalPipe } from '@angular/common';
import { forwardRef, NgModule } from '@angular/core';

import { IdentifierDirective } from './identifier.directive';
import { PaginationDirective } from './pagination.directive';
import { FocusDirective } from './focus.directive';
import { GoToDetailsDirective } from './go-to-details.directive';
import { SelectAllDirective } from './select-all.directive';
import { GoToCreateDirective } from './go-to-create.directive';
import { ConfirmDirective } from './confirm.directive';
import { OpenInModalDirective } from './open-in-modal.directive';

@NgModule({
  declarations: [
    FocusDirective,
  ],
  imports: [
    CommonModule,
    ConfirmDirective,
    forwardRef(() => GoToCreateDirective),
    GoToDetailsDirective,
    IdentifierDirective,
    PaginationDirective,
    SelectAllDirective,
    ConfirmDirective,
    OpenInModalDirective,
  ],
  exports: [
    ConfirmDirective,
    FocusDirective,
    forwardRef(() => GoToCreateDirective),
    GoToDetailsDirective,
    IdentifierDirective,
    PaginationDirective,
    SelectAllDirective,
    ConfirmDirective,
    OpenInModalDirective,
  ],
  providers: [
    DecimalPipe,
  ],
})
export class CommonDirectivesModule { }
